import { useContext, useState } from "react";
import { ButtonDS, GlobalIcon } from "get-life-storybook-ts";
import { I18nContext } from "../../../../../context/i18n.context";

const HelpPage = () => {
  const {
    state: { translate },
  } = useContext(I18nContext);

  const [openFaq, setOpenFaq] = useState<number | null>(null);

  const faqs = [
    { q: translate("newDashboard.claims.faq1.q"), a: translate("newDashboard.claims.faq1.a") },
    { q: translate("newDashboard.claims.faq2.q"), a: translate("newDashboard.claims.faq2.a") },
    { q: translate("newDashboard.claims.faq3.q"), a: translate("newDashboard.claims.faq3.a") },
  ];

  const steps = [
    {
      num: "1",
      title: translate("newDashboard.claims.step1.title"),
      desc: translate("newDashboard.claims.step1.desc"),
      icon: "PhoneIcon" as const,
    },
    {
      num: "2",
      title: translate("newDashboard.claims.step2.title"),
      desc: translate("newDashboard.claims.step2.desc"),
      icon: "FileInvoiceIcon" as const,
    },
    {
      num: "3",
      title: translate("newDashboard.claims.step3.title"),
      desc: translate("newDashboard.claims.step3.desc"),
      icon: "CircleCheckFilledIcon" as const,
    },
  ];

  const cardStyle: React.CSSProperties = {
    backgroundColor: "#fff",
    borderRadius: 12,
    boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
    padding: 24,
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 24, maxWidth: 760 }}>
      {/* ── HEADER ─────────────────────────────────────────────────────── */}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "flex-start",
          justifyContent: "space-between",
          gap: 16,
        }}
      >
        <div>
          <h1 style={{ fontSize: 26, fontWeight: 700, color: "#1e293b", margin: 0, lineHeight: 1.3 }}>
            {translate("newDashboard.claims.title")}
          </h1>
          <p style={{ fontSize: 16, color: "#64748b", marginTop: 8, lineHeight: 1.6, maxWidth: 520 }}>
            {translate("newDashboard.claims.subtitle")}
          </p>
        </div>
        {/* <button
          onClick={() => {
            // TODO: link to actual PDF endpoint
            window.open("#", "_blank");
          }}
          title={translate("newDashboard.claims.downloadGuideTooltip")}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            padding: "10px 18px",
            backgroundColor: "#f8fafc",
            border: "1px solid #e2e8f0",
            borderRadius: 10,
            cursor: "pointer",
            fontSize: 14,
            fontWeight: 600,
            color: "#475569",
            transition: "all 0.15s",
            whiteSpace: "nowrap",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#f1f5f9";
            e.currentTarget.style.borderColor = "#cbd5e1";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "#f8fafc";
            e.currentTarget.style.borderColor = "#e2e8f0";
          }}
        >
          <GlobalIcon iconName="DownloadIcon" size="XS" color="#475569" />
          {translate("newDashboard.claims.downloadGuide")}
        </button> */}
      </div>

      {/* ── EMERGENCY CONTACT ──────────────────────────────────────────── */}
      <div
        style={{
          ...cardStyle,
          backgroundColor: "#f8fafc",
          border: "1px solid #e2e8f0",
        }}
      >
        <h2 style={{ fontSize: 17, fontWeight: 700, color: "#1e293b", margin: "0 0 20px" }}>
          {translate("newDashboard.claims.emergencyTitle")}
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" style={{ marginBottom: 20 }}>
          {/* Phone */}
          <a
            href={`tel:${translate("newDashboard.claims.phoneNumber").replace(/\s/g, "")}`}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 16,
              padding: 20,
              backgroundColor: "#fff",
              borderRadius: 10,
              border: "1px solid #e2e8f0",
              textDecoration: "none",
              transition: "border-color 0.15s",
            }}
            onMouseEnter={(e) => { (e.currentTarget as HTMLElement).style.borderColor = "#94a3b8"; }}
            onMouseLeave={(e) => { (e.currentTarget as HTMLElement).style.borderColor = "#e2e8f0"; }}
          >
            <div
              style={{
                width: 48,
                height: 48,
                borderRadius: 12,
                backgroundColor: "#ecfdf5",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <GlobalIcon iconName="PhoneIcon" size="XS" color="#059669" colorFill="transparent" />
            </div>
            <div>
              <p style={{ fontSize: 13, fontWeight: 500, color: "#64748b", margin: 0 }}>
                {translate("newDashboard.claims.phone")}
              </p>
              <p style={{ fontSize: 22, fontWeight: 800, color: "#1e293b", margin: "2px 0 0", letterSpacing: 0.5 }}>
                {translate("newDashboard.claims.phoneNumber")}
              </p>
            </div>
          </a>

          {/* Email */}
          <a
            href={`mailto:${translate("newDashboard.claims.emailAddress")}`}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 16,
              padding: 20,
              backgroundColor: "#fff",
              borderRadius: 10,
              border: "1px solid #e2e8f0",
              textDecoration: "none",
              transition: "border-color 0.15s",
            }}
            onMouseEnter={(e) => { (e.currentTarget as HTMLElement).style.borderColor = "#94a3b8"; }}
            onMouseLeave={(e) => { (e.currentTarget as HTMLElement).style.borderColor = "#e2e8f0"; }}
          >
            <div
              style={{
                width: 48,
                height: 48,
                borderRadius: 12,
                backgroundColor: "#eef2ff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <GlobalIcon iconName="MailIcon" size="XS" color="#4f46e5" />
            </div>
            <div>
              <p style={{ fontSize: 13, fontWeight: 500, color: "#64748b", margin: 0 }}>
                {translate("newDashboard.claims.email")}
              </p>
              <p style={{ fontSize: 18, fontWeight: 700, color: "#1e293b", margin: "2px 0 0" }}>
                {translate("newDashboard.claims.emailAddress")}
              </p>
            </div>
          </a>
        </div>

        <p style={{ fontSize: 14, color: "#64748b", fontStyle: "italic", margin: 0, lineHeight: 1.5 }}>
          {translate("newDashboard.claims.emergencyNote")}
        </p>
      </div>

      {/* ── STEP-BY-STEP PROCESS ───────────────────────────────────────── */}
      <div style={cardStyle}>
        <h2 style={{ fontSize: 17, fontWeight: 700, color: "#1e293b", margin: "0 0 24px" }}>
          {translate("newDashboard.claims.processTitle")}
        </h2>

        <div style={{ display: "flex", flexDirection: "column", gap: 0 }}>
          {steps.map((step, idx) => (
            <div
              key={idx}
              style={{
                display: "flex",
                gap: 16,
                position: "relative",
                paddingBottom: idx < steps.length - 1 ? 32 : 0,
              }}
            >
              {/* Timeline line */}
              {idx < steps.length - 1 && (
                <div
                  style={{
                    position: "absolute",
                    left: 23,
                    top: 48,
                    bottom: 0,
                    width: 2,
                    backgroundColor: "#e2e8f0",
                  }}
                />
              )}

              {/* Step number circle */}
              <div
                style={{
                  width: 48,
                  height: 48,
                  borderRadius: "50%",
                  backgroundColor: idx === 0 ? "#ecfdf5" : idx === 1 ? "#eef2ff" : "#ecfdf5",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                  zIndex: 1,
                }}
              >
                <span style={{ fontSize: 18, fontWeight: 800, color: idx === 0 ? "#059669" : idx === 1 ? "#4f46e5" : "#059669" }}>
                  {step.num}
                </span>
              </div>

              {/* Content */}
              <div style={{ flex: 1, paddingTop: 4 }}>
                <h3 style={{ fontSize: 16, fontWeight: 700, color: "#1e293b", margin: "0 0 6px" }}>
                  {step.title}
                </h3>
                <p style={{ fontSize: 15, color: "#64748b", margin: 0, lineHeight: 1.6 }}>
                  {step.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* ── FAQ ACCORDION ──────────────────────────────────────────────── */}
      <div style={cardStyle}>
        <h2 style={{ fontSize: 17, fontWeight: 700, color: "#1e293b", margin: "0 0 16px" }}>
          {translate("newDashboard.claims.faqTitle")}
        </h2>

        <div style={{ display: "flex", flexDirection: "column", gap: 0 }}>
          {faqs.map((faq, idx) => {
            const isOpen = openFaq === idx;
            return (
              <div
                key={idx}
                style={{
                  borderBottom: idx < faqs.length - 1 ? "1px solid #f1f5f9" : "none",
                }}
              >
                <button
                  onClick={() => setOpenFaq(isOpen ? null : idx)}
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 12,
                    padding: "18px 0",
                    border: "none",
                    background: "none",
                    cursor: "pointer",
                    textAlign: "left",
                  }}
                >
                  <span style={{ fontSize: 15, fontWeight: 600, color: "#1e293b", flex: 1 }}>
                    {faq.q}
                  </span>
                  <span
                    style={{
                      display: "flex",
                      transition: "transform 0.2s",
                      transform: `rotate(${isOpen ? 180 : 0}deg)`,
                      flexShrink: 0,
                    }}
                  >
                    <GlobalIcon iconName="ChevronDown" size="XS" color="#94a3b8" />
                  </span>
                </button>
                <div
                  style={{
                    overflow: "hidden",
                    transition: "max-height 0.3s ease, opacity 0.2s ease",
                    maxHeight: isOpen ? 200 : 0,
                    opacity: isOpen ? 1 : 0,
                  }}
                >
                  <p style={{ fontSize: 15, color: "#64748b", lineHeight: 1.6, margin: "0 0 18px", paddingRight: 32 }}>
                    {faq.a}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default HelpPage;
